export const renderMoreReadableName = name =>
  (name.charAt(0).toUpperCase() + name.slice(1, name.length))
    .split("_")
    .join(" ");



// WEBPACK FOOTER //
// ./src/component/TaskCreator/renderMoreReadableName.js